/**
 * Shim: el cliente del ledger (`GET /api/me/credits/transactions`) se extrajo a
 * `@orborix/billing-client` (2026-07-22) para compartirlo entre las apps de la
 * familia. El filtrado/merge específico de speak sigue en `walletModel.ts`.
 */
import { apiFetch } from '../lib/apiClient.js';
import type { ReviewDay } from './walletModel.js';

export {
  WalletApiError,
  fetchLedgerTransactions,
  type LedgerKind,
  type LedgerTxn,
} from '@orborix/billing-client';

/**
 * Lo cobrado por el repaso de correcciones, por día local
 * (`GET /api/me/credits/review-days`): la billetera muestra una línea por día.
 * Un no-2xx tira (no se inventa un cero).
 */
export async function fetchReviewDays(signal?: AbortSignal): Promise<ReviewDay[]> {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const res = await apiFetch(`/api/me/credits/review-days?tz=${encodeURIComponent(tz)}`, {
    ...(signal ? { signal } : {}),
  });
  if (!res.ok) throw new Error(`credits/review-days: HTTP ${res.status}`);
  const json = (await res.json()) as { days?: ReviewDay[] };
  if (!Array.isArray(json.days)) throw new Error('credits/review-days: respuesta inválida');
  return json.days;
}
